import { Button, TableCell, TableRow, TableRowHeader } from '@/common'
import { MaterialOutputItem } from '@/api/EmissionReportModel'
import useI18n from '@/shared/hooks/useI18n'
import LocalizedNumberFlow from '@/components/LocalizednNumberFlow'

export default function OutputTableRow({
  title,
  item,
  index,
  onEdit
}: {
  index: number
  title: string
  item: MaterialOutputItem
  onEdit: (cnCode: string) => void
}) {
  const { t } = useI18n()
  return (
    <TableRow key={item.cnCode}>
      {index === 0 ? (
        <TableRowHeader className="font-semibold">{title}</TableRowHeader>
      ) : (
        <TableCell />
      )}
      <TableCell>{item.cnCode}</TableCell>
      <TableCell>-</TableCell>
      <TableCell>
        <LocalizedNumberFlow value={item.carbonContent.quantity} />
      </TableCell>
      <TableCell>
        <LocalizedNumberFlow value={item.carbonContent.emission} />
      </TableCell>
      <TableCell>
        <div className="grid grid-cols-2 gap-2">
          <Button variant="txt-default" sizeType="sm" onClick={() => onEdit(item.cnCode)}>
            {t('common:actions.edit')}
          </Button>
        </div>
      </TableCell>
    </TableRow>
  )
}
